<template>
  <v-dialog
    v-model="getModalVisualizarPosVenda"
    persistent
    max-width="960px"
    transition="dialog-transition"
  >
    <v-card outlined>
      <v-card-title>
        <v-tabs app grow v-model="tabs" class="hidden-sm-and-down">
          <v-tab>
            <span>DADOS DA VENDA</span>
          </v-tab>

          <v-tab>
            <span>REGISTROS DE ATIVIDADES</span>
          </v-tab>
        </v-tabs>
      </v-card-title>

      <v-card-text>
        <v-tabs-items v-model="tabs" class="pa-8">
          <v-tab-item>
            <VCardVenda />
          </v-tab-item>
          <v-tab-item>
            <ListarAtividades />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default"
          @click="setModalVisualizarPosVenda(false)"
          outlined
          :loading="$store.getters.getOverlay"
          >Voltar</v-btn
        >
        <v-btn
          color="error"
          outlined
          @click="setModalExcluirPosVenda(true)"
          :loading="$store.getters.getOverlay"
          v-if="$helper.verificaPermissao('excluir-pos-venda-crm')"
          >Excluir</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="success" outlined @click="setModalFinalizarPosVenda(true)" v-if="getPosVenda.status != 'FINALIZADO' && $helper.verificaPermissao('finalizar-pos-venda-crm')"
          >Finalizar</v-btn
        >
      </v-card-actions>
    </v-card>
    <ModalExcluir />
    <ModalVisualizarContato />
    <ModalFinalizar />
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ListarAtividades from "@/pages/crm/posVenda/atividade/Listar";
import VCardVenda from "@/pages/crm/posVenda/VCardVenda";
import ModalExcluir from "@/pages/crm/posVenda/ModalExcluir";
import ModalFinalizar from "@/pages/crm/posVenda/ModalFinalizar";
import ModalVisualizarContato from "@/pages/contato/ModalCadastro";

export default {
  components: {
    VCardVenda,
    ListarAtividades,
    ModalExcluir,
    ModalVisualizarContato,
    ModalFinalizar,
  },
  data() {
    return {
      tabs: 0,
    };
  },

  computed: {
    ...mapGetters(["getModalVisualizarPosVenda", "getModalCadastroContato", "getPosVenda"]),
  },
  methods: {
    ...mapActions([
      "setModalVisualizarPosVenda",
      "setModalExcluirPosVenda",
      "setModalFinalizarPosVenda",
    ]),
  },
};
</script>